/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingBase } from '../../models/thermoforming-base';

export interface MgmtThermoformingBaseControllerSortUp$Params {
  id: number;
}

export function mgmtThermoformingBaseControllerSortUp(http: HttpClient, rootUrl: string, params: MgmtThermoformingBaseControllerSortUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
  const rb = new RequestBuilder(rootUrl, mgmtThermoformingBaseControllerSortUp.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingBase>;
    })
  );
}

mgmtThermoformingBaseControllerSortUp.PATH = '/api/mgmt/thermoforming-base/{id}/sort-up';
